import { render, staticRenderFns } from "./PosDocumentTable.vue?vue&type=template&id=44d99092&"
import script from "./PosDocumentTable.vue?vue&type=script&lang=js&"
export * from "./PosDocumentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports